module.exports = __webpack_public_path__ + "static/media/eib_1.c81f6659.png";